import { Link } from 'react-router-dom';

export default function ShippingPolicy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <div className="bg-[#F5F2EE] border-b border-[#1C1C1C]/8">
        <div className="max-w-7xl mx-auto px-8 md:px-14 py-16 md:py-24">
          <nav className="flex items-center gap-2 text-xs text-[#1C1C1C]/35 mb-8">
            <Link to="/" className="hover:text-[#ec3145] transition-colors cursor-pointer">მთავარი</Link>
            <i className="ri-arrow-right-s-line text-[10px]"></i>
            <span className="text-[#1C1C1C]/55">მიწოდების პოლიტიკა</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-bold text-[#1C1C1C] tracking-tight mb-4">
            მიწოდების პოლიტიკა
          </h1>
          <p className="text-[#1C1C1C]/45 text-base md:text-lg max-w-2xl">
            სრული ინფორმაცია მიწოდების ვადების, ღირებულებისა და პროცესის შესახებ.
          </p>
          <p className="text-xs text-[#1C1C1C]/25 mt-6">ბოლო განახლება: 27 აპრილი, 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-8 md:px-14 py-16 md:py-24">
        <div className="prose prose-lg max-w-none">
          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">1. მიწოდების ტერიტორია</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              Phoenix Georgia ახორციელებს მიწოდებას მთელი საქართველოს ტერიტორიაზე. მიწოდება ხორციელდება შემდეგ ქალაქებში და რეგიონებში:
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {['თბილისი', 'ბათუმი', 'ქუთაისი', 'რუსთავი', 'გორი', 'ზუგდიდი', 'ფოთი', 'თელავი', 'ახალციხე', 'მცხეთა', 'სამტრედია', 'სხვა რეგიონები'].map((city) => (
                <div key={city} className="flex items-center gap-2 bg-[#F5F2EE] rounded-md px-3 py-2">
                  <i className="ri-map-pin-line text-[#ec3145] text-xs"></i>
                  <span className="text-sm text-[#1C1C1C]/60">{city}</span>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">2. მიწოდების ვადები</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              მიწოდების ვადა დამოკიდებულია პროდუქტის ხელმისაწვდომობაზე, მდებარეობაზე და შეკვეთის მოცულობაზე:
            </p>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-[#1C1C1C]/10">
                    <th className="text-left py-3 px-4 text-[#1C1C1C]/40 font-medium text-xs uppercase tracking-wider">მდებარეობა</th>
                    <th className="text-left py-3 px-4 text-[#1C1C1C]/40 font-medium text-xs uppercase tracking-wider">სტანდარტული მიწოდება</th>
                    <th className="text-left py-3 px-4 text-[#1C1C1C]/40 font-medium text-xs uppercase tracking-wider">სწრაფი მიწოდება</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-[#1C1C1C]/5">
                    <td className="py-3 px-4 text-[#1C1C1C]/70">თბილისი</td>
                    <td className="py-3 px-4 text-[#1C1C1C]/70">1-2 სამუშაო დღე</td>
                    <td className="py-3 px-4 text-[#1C1C1C]/70">იმავე დღეს*</td>
                  </tr>
                  <tr className="border-b border-[#1C1C1C]/5">
                    <td className="py-3 px-4 text-[#1C1C1C]/70">ბათუმი, ქუთაისი</td>
                    <td className="py-3 px-4 text-[#1C1C1C]/70">2-3 სამუშაო დღე</td>
                    <td className="py-3 px-4 text-[#1C1C1C]/70">1-2 სამუშაო დღე</td>
                  </tr>
                  <tr className="border-b border-[#1C1C1C]/5">
                    <td className="py-3 px-4 text-[#1C1C1C]/70">სხვა ქალაქები</td>
                    <td className="py-3 px-4 text-[#1C1C1C]/70">3-5 სამუშაო დღე</td>
                    <td className="py-3 px-4 text-[#1C1C1C]/70">2-3 სამუშაო დღე</td>
                  </tr>
                  <tr>
                    <td className="py-3 px-4 text-[#1C1C1C]/70">მთიანი რეგიონები</td>
                    <td className="py-3 px-4 text-[#1C1C1C]/70">5-7 სამუშაო დღე</td>
                    <td className="py-3 px-4 text-[#1C1C1C]/70">3-5 სამუშაო დღე</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-xs text-[#1C1C1C]/30 mt-3">* იმავე დღის მიწოდება შესაძლებელია მხოლოდ შეკვეთის დადასტურების შემდეგ 14:00 საათამდე. სპეციალური შეკვეთები შეიძლება მოითხოვდეს დამატებით დროს.</p>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">3. მიწოდების ღირებულება</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              მიწოდების ღირებულება დამოკიდებულია მიწოდების მისამართზე და შეკვეთის მოცულობაზე:
            </p>
            <ul className="space-y-3 text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">თბილისი:</strong> უფასო მიწოდება 500 GEL-ზე მეტი შეკვეთებისთვის. 500 GEL-მდე შეკვენებზე — 15 GEL.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">ბათუმი, ქუთაისი:</strong> უფასო მიწოდება 1000 GEL-ზე მეტი შეკვეთებისთვის. 1000 GEL-მდე — 30 GEL.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">სხვა რეგიონები:</strong> ფასი განისაზღვრება ინდივიდუალურად შეკვეთის მოცულობისა და მანძილის მიხედვით.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">სპეციალური მომსახურება:</strong> მძიმე ან მოცულობითი პროდუქტებისთვის (მარმარილო, გრანიტი, დიდი ფორმატის ფილები) შეიძლება დაჭირდეს დამატებითი სატვირთო მომსახურება.</span>
              </li>
            </ul>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">4. მიწოდების პროცესი</h2>
            <div className="space-y-4">
              <div className="flex gap-4">
                <div className="w-8 h-8 rounded-full bg-[#ec3145] text-white flex items-center justify-center text-sm font-bold flex-shrink-0">1</div>
                <div>
                  <h4 className="text-sm font-bold text-[#1C1C1C] mb-1">შეკვეთის დამუშავება</h4>
                  <p className="text-sm text-[#1C1C1C]/55 leading-relaxed">შეკვეთა დამუშავდება 1 სამუშაო დღის განმავლობაში. მიიღებთ დადასტურების ელფოსტას შეკვეთის დეტალებით.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-8 h-8 rounded-full bg-[#ec3145] text-white flex items-center justify-center text-sm font-bold flex-shrink-0">2</div>
                <div>
                  <h4 className="text-sm font-bold text-[#1C1C1C] mb-1">მომზადება და შეფუთვა</h4>
                  <p className="text-sm text-[#1C1C1C]/55 leading-relaxed">პროდუქტი მომზადდება და შეფუთული იქნება უსაფრთხოების სტანდარტების შესაბამისად, რათა თავიდან იქნას აცილებული დაზიანება ტრანსპორტირებისას.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-8 h-8 rounded-full bg-[#ec3145] text-white flex items-center justify-center text-sm font-bold flex-shrink-0">3</div>
                <div>
                  <h4 className="text-sm font-bold text-[#1C1C1C] mb-1">გადაზიდვა</h4>
                  <p className="text-sm text-[#1C1C1C]/55 leading-relaxed">პროდუქტი გაიგზავნება ჩვენი პარტნიორი გადამზიდავი კომპანიის მეშვეობით. მიიღებთ ტრეკინგის ინფორმაციას, სადაც შეგიძლიათ მისდიოთ თქვენი შეკვეთის სტატუსს.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-8 h-8 rounded-full bg-[#ec3145] text-white flex items-center justify-center text-sm font-bold flex-shrink-0">4</div>
                <div>
                  <h4 className="text-sm font-bold text-[#1C1C1C] mb-1">მიღება</h4>
                  <p className="text-sm text-[#1C1C1C]/55 leading-relaxed">პროდუქტის მიღებისას გთხოვთ, შეამოწმოთ შეფუთვა და პროდუქტის მდგომარეობა. ნებისმიერი დაზიანება ან დეფექტი უნდა დააფიქსიროთ მიღებისთანავე.</p>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">5. მიწოდების შეფერხება</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              შემდეგ შემთხვევებში მიწოდება შეიძლება შეფერხდეს:
            </p>
            <ul className="space-y-3 text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>არასწორი ან არასრული მისამართის მითითება</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>მიმღები პირის არ ყოფნა მითითებულ მისამართზე მიწოდების დროს</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>გაუვალი გზები არამოსაწვდომი მისამართი</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>ძლიერი ამინდის პირობები ან სტიქიური მოვლენები</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>საქართველოს სახელმწიფო არდღეობები</span>
              </li>
            </ul>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mt-4">
              მიწოდების შეფერხების შემთხვევაში ჩვენ დაგიკავშირდებით და შევთანხმდებით ახალ მიწოდების თარიღზე.
            </p>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">6. თვითმიწოდება</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              თქვენ ასევე შეგიძლიათ აიღოთ შეკვეთა ჩვენი ოფისიდან ან საწყობიდან:
            </p>
            <div className="bg-[#F5F2EE] rounded-lg p-5 md:p-6">
              <div className="flex items-start gap-3 mb-3">
                <i className="ri-map-pin-line text-[#ec3145] mt-0.5"></i>
                <div>
                  <p className="text-sm font-bold text-[#1C1C1C] mb-1">მისამართი</p>
                  <p className="text-sm text-[#1C1C1C]/55">გელოვანის ქ. N13, თბილისი, საქართველო</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-time-line text-[#ec3145] mt-0.5"></i>
                <div>
                  <p className="text-sm font-bold text-[#1C1C1C] mb-1">სამუშაო საათები</p>
                  <p className="text-sm text-[#1C1C1C]/55">ორშ–შაბ: 09:30–19:30</p>
                </div>
              </div>
            </div>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mt-4">
              თვითმიწოდებისას გთხოვთ, წინასწარ დაგვიკავშირდეთ, რათა დავრწმუნდეთ, რომ თქვენი შეკვეთა მზად არის გაცემისთვის.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">7. კონტაქტი</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              მიწოდებასთან დაკავშირებული კითხვებისთვის გთხოვთ, დაგვიკავშირდეთ:
            </p>
            <div className="bg-[#F5F2EE] rounded-lg p-6 md:p-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-[#ec3145]"></i>
                  </div>
                  <div>
                    <p className="text-xs text-[#1C1C1C]/35 mb-0.5">ელფოსტა</p>
                    <a href="mailto:info@phoenix.ge" className="text-sm text-[#1C1C1C]/70 hover:text-[#ec3145] transition-colors cursor-pointer">info@phoenix.ge</a>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-[#ec3145]"></i>
                  </div>
                  <div>
                    <p className="text-xs text-[#1C1C1C]/35 mb-0.5">ტელეფონი</p>
                    <a href="tel:+995599872020" className="text-sm text-[#1C1C1C]/70 hover:text-[#ec3145] transition-colors cursor-pointer">+995 599 87 20 20</a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}